<div>
    <div style="height: 30px;text-align: center;background-color: #1b2464;">
        <h5>Confirmation</h5>
    </div>

    <div style="padding: 4%; height: 80px; display: flex; align-items: center; overflow: auto;">
        <!--  <div *ngIf="dialogData.message">
        <h4>{{ dialogData.heading }}</h4>
        <p style="padding-left: 24px;">{{ dialogData.message }}</p>
    </div>
    <div *ngIf="!dialogData.message">
        <h4>{{ dialogData.heading }}</h4>
    </div> -->
        <div>
            <h4>{{ dialogData.heading }}</h4>
        </div>
    </div>
    <div class="options">
        <button mat-stroked-button color="primary" [mat-dialog-close]="true" class="okay"
            style="float: right; width: 110px !important;"> {{rightBtn}} </button>
        <button mat-stroked-button color="primary" [mat-dialog-close]="false"
            style="float: right; width: 91px !important;">
            {{leftBtn}} </button>
        <button *ngIf="showCancel" mat-stroked-button color="primary" [mat-dialog-close]
            style="width: 91px !important; margin-left: 12px;"> Cancel </button>
    </div>
</div>






<!-- <div class="messages">
    <div *ngIf="dialogData.message">
        <h4>{{ dialogData.heading }}</h4>
        <p style="padding-left: 24px;">{{ dialogData.message }}</p>
    </div>
    <div *ngIf="!dialogData.message">
        <h4>{{ dialogData.heading }}</h4>
    </div>
</div>
<div class="options">
    <button mat-stroked-button color="primary" [mat-dialog-close]="true" class="okay"
        style="float: right; width: 110px !important;"> {{rightBtn}} </button>
    <button mat-stroked-button color="primary" [mat-dialog-close]="false" style="float: right; width: 91px !important;">
        {{leftBtn}} </button>
    <button *ngIf="showCancel" mat-stroked-button color="primary" [mat-dialog-close]
        style="width: 91px !important; margin-left: 12px;"> Cancel </button>
</div> -->